<template>
  <PaginationDisableJS
    :current="pageNumber"
    :total="total"
    :per-page="perPage"
    :page-range="1"
    :first-page-parameterless="true"
    @pageChanged="pageChanged"
  />
</template>

<script>
import PaginationDisableJS from '@app/design-system/base/pagination/pagination-disable-js.vue'
export default {
  name: 'TeacherListPagination',
  components: {
    PaginationDisableJS
  },
  inject: ['pagination'],
  computed: {
    pageNumber () {
      return this.pagination?.data?.page_number
    },
    total () {
      return this.pagination?.data?.total
    },
    perPage () {
      return this.pagination?.data?.per_page
    }
  },
  methods: {
    pageChanged (page) {
      this.$emit('pageChanged', page)
    }
  }
}
</script>

<style scoped>

</style>
